<template>
    <div class="container">
        <step />
        <actionArea />
    </div>
</template>

<script>
    import step from "../components/public/step";
    import actionArea from "../components/public/actionArea";
    export default {
        name: 'IDcard',
        components:{step,actionArea},
        data(){
            return{
                stepNum:1,
            }
        }
    }
</script>

<style>
    .container{
        width: 1000px;
        height: auto;
        margin: 10px auto;
    }
</style>
